export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/phone.44685064-6ee4d8.png";